export default __webpack_public_path__ + "static/media/frosty1.34a112ce.png";